import React from "react";
import tw from "twin.macro";
// import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { useLocation } from 'react-router-dom';
import logoImage from 'images/latest/lvvp2.png';
import GGZKwaliteitsstatuut from 'images/kwaliteit/kwaliteitsstatuut historie.pdf'; // Import the PDF file
import AVBB from 'images/kwaliteit/AV BB.pdf';
import Privacy from 'images/kwaliteit/Privacystatement Website LVVP.pdf';
// import LogoImage from "images/logo.svg";
// import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
// import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
// import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
  

const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`px-4 sm:px-0 sm:w-1/4 md:w-auto mt-12`;

const ColumnHeading = tw.h5`uppercase font-bold`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300`;

const Divider = tw.div`my-16 border-b-2 border-gray-300 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoText = tw.h5`ml-2 text-sm font-black tracking-wider text-gray-800`;
const handleDownload = (event) => {
  event.preventDefault();
  const link = document.createElement('a');
  link.href = GGZKwaliteitsstatuut; // Use the imported file path
  link.download = 'GGZ kwaliteitsstatuut.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDownloadAB = (event) => {
  event.preventDefault();
  const link = document.createElement('a');
  link.href = AVBB; // Use the imported file path
  link.download = 'AV BB.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDownloadPrivacy = (event) => {
  event.preventDefault();
  const link = document.createElement('a');
  link.href = Privacy; // Use the imported file path
  link.download = 'Privacystatement Website LVVP.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default () => {
  const location = useLocation();
  const isMainPage = location.pathname === '/';
  
  let Container;
  
  if (!isMainPage) {
    Container = tw.div`relative bg-white text-gray-700 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
  } else {
    Container = tw.div`relative bg-gray-200 text-gray-700 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
  }
  return (
    <Container>
      <Content>
        <SixColumns>
       
          <Column>
            <ColumnHeading>Therapie</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/therapie/cgt">CGT</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/therapie/emdr-ie">Traumatherapie</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/therapie/kpsp">KPSP</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/therapie/schrijftherapie">Schrijftherapie</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/therapie/tarieven">Tarieven</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Onderzoek</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/onderzoek/adhd">ADHD</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/onderzoek/autisme">Autisme</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/onderzoek/tarieven">Tarieven</Link>
              </LinkListItem>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Supervisie</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/supervisie">Supervisie</Link>
              </LinkListItem>
     
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Praktisch</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/"onClick={handleDownloadAB} >Algemene Voorwaarden</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/" onClick={handleDownloadPrivacy}>Privacystatement</Link>
              </LinkListItem>
              <LinkListItem>
      <Link href="/" onClick={handleDownload}>GGZ kwaliteitsstatuut</Link>
    </LinkListItem>
     
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Contact</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/contact">Maak een afspraak</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/vragen">Veel gestelde vragen</Link>
              </LinkListItem>
            </LinkList>
          </Column>
       
        </SixColumns>
        <Divider />
        <ThreeColRow>
        <img src={logoImage} alt="Logo" style={{ width: '200px', height: '200' }} />

          <LogoContainer>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <LogoText style={{ marginTop: '36px' }}>
              © {new Date().getFullYear()} Psychologenpraktijk BB. Alle rechten voorbehouden | Made by: J.M Bekendam
            </LogoText>
          </div>
          </LogoContainer>
          <LogoContainer>

    </LogoContainer>


        </ThreeColRow>
      </Content>
    </Container>
  );
};
